var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFlowArrow = function SvgIconFlowArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.043 3.043a1 1 0 0 1 1.414 0l3.75 3.75a1 1 0 0 1 0 1.414l-3.75 3.75a1 1 0 0 1-1.414-1.414L20.086 8.5H16.5A3.5 3.5 0 0 0 13 12a5.5 5.5 0 0 1-5.39 5.499A3.627 3.627 0 0 1 .5 16.5a3.625 3.625 0 0 1 7.11-1.002A3.5 3.5 0 0 0 11 12a5.5 5.5 0 0 1 5.5-5.5h3.586l-2.043-2.043a1 1 0 0 1 0-1.414M4.125 14.875a1.625 1.625 0 1 0 0 3.25 1.625 1.625 0 0 0 0-3.25",
    clipRule: "evenodd"
  })));
};
export default SvgIconFlowArrow;